<div
  class="flex h-9 items-center gap-1 rounded-lg bg-zinc-900 pr-1 pl-3 inset-ring inset-ring-zinc-750">
  <code
    class="min-w-0 flex-1 truncate font-mono text-sm tracking-tight text-zinc-100 select-all"
    [attr.aria-hidden]="masked() || null">
    {{ displayValue() }}
  </code>
  @if (secret()) {
    <vx-icon-button
      [icon]="revealed() ? 'eye-slash' : 'eye'"
      variant="ghost"
      size="sm"
      tone="secondary"
      [ariaLabel]="toggleLabel() ?? ''"
      (click)="toggleReveal()" />
  }
  <vx-icon-button
    icon="copy"
    variant="ghost"
    size="sm"
    tone="secondary"
    [ariaLabel]="copyLabel()"
    (click)="copy()" />
</div>
